
// // webpack.config.js
// const AutoImport = require('unplugin-auto-import/webpack')
// const Components = require('unplugin-vue-components/webpack')
// const { ElementPlusResolver } = require('unplugin-vue-components/resolvers')

var isPro = process.env.NODE_ENV === 'production' //process.env.NODE_ENV用于区分是生产环境还是开发环境
//根据环境不同导出不同的baseURL
module.exports = {

    baseURL: isPro ? '' : 'http://127.0.0.1:8008',
    // plugins: [
    //     AutoImport({
    //       resolvers: [ElementPlusResolver()],
    //     }),
    //     Components({
    //       resolvers: [ElementPlusResolver()],
    //     }),
    //   ],
}


